<template>
  <section class="download text-center" id="download">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 col-xl-9 mx-auto">
          <!-- Download Card principale -->
          <div class="download-card fade-in-up">
            <div class="download-card-content">
              <div class="download-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
              </div>
              <h2 class="download-title">Scarica AppScontrini</h2>
              <p class="download-subtitle">
                Inizia subito a partecipare alla Lotteria degli Scontrini.<br>
                <strong>Gratuita • Senza registrazione • Sempre con te</strong>
              </p>
              
              <div class="download-badges">
                <a href="https://isige.st/app-scontrini" class="store-badge" target="_blank" rel="noopener">
                  <img :src="googlePlayBadge" alt="Scarica su Google Play">
                </a>
                <a href="https://isige.st/app-scontrini" class="store-badge" target="_blank" rel="noopener">
                  <img :src="appStoreBadge" alt="Scarica su App Store">
                </a>
              </div>
              
              <div class="download-trust">
                <div class="trust-item">
                  <span>⭐ 4.8 su App Store</span>
                </div>
                <div class="trust-divider"></div>
                <div class="trust-item">
                  <span>📱 100k+ download</span>
                </div>
                <div class="trust-divider"></div>
                <div class="trust-item">
                  <span>🔒 100% sicura</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import googlePlayBadge from '@/assets/images/google-play-badge.svg'
import appStoreBadge from '@/assets/images/app-store-badge.svg'

export default {
  name: 'DownloadSection',
  data() {
    return {
      googlePlayBadge,
      appStoreBadge
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.download {
  position: relative;
  padding: 80px 0;
  background: #ffffff;
  
  .download-card {
    background: #1e3c72;
    border-radius: 24px;
    padding: 60px 40px;
    color: white;
    
    @media (max-width: 768px) {
      padding: 48px 24px;
      border-radius: 20px;
    }
  }
  
  .download-card-content {
    max-width: 600px;
    margin: 0 auto;
  }
  
  .download-icon-wrapper {
    width: 64px;
    height: 64px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    color: white;
  }
  
  .download-title {
    font-size: 2.2rem;
    font-weight: 700;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    
    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
  }
  
  .download-subtitle {
    font-size: 1.1rem;
    opacity: 0.9;
    margin-bottom: 36px;
    line-height: 1.6;
    
    strong {
      opacity: 1;
      font-weight: 500;
      font-size: 0.95rem;
      letter-spacing: 0.5px;
    }
    
    @media (max-width: 768px) {
      font-size: 1rem;
      
      br {
        display: none;
      }
    }
  }
  
  .download-badges {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 40px;
    
    @media (max-width: 576px) {
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    
    .store-badge {
      display: block;
      transition: transform 0.2s ease;
      
      img {
        height: 52px;
        width: auto;
        
        @media (max-width: 768px) {
          height: 48px;
        }
      }
      
      &:hover {
        transform: translateY(-3px);
      }
    }
  }
  
  .download-trust {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding-top: 32px;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 16px;
    }
    
    .trust-item {
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      opacity: 0.85;
    }
    
    .trust-divider {
      width: 4px;
      height: 4px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
}

.fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

